import { apiGet } from "./apiClient";

let cache = null;
let pending = null;
let revision = 0;
// Keep the full administrative directory; filter only human-agent consumers.
export function fetchSrmUsers({ force = false, strict = false } = {}) {
  if (!force && cache) return Promise.resolve(cache);
  if (!force && pending) return pending;
  if (force) cache = null;
  const current = ++revision;
  const request = apiGet("/auth/get_all_users").then(res => {
    if (!res.data?.success || !Array.isArray(res.data.data)) throw new Error("Could not refresh agent eligibility.");
    const users = res.data.data.map(u => ({
      id: u.id,
      fullName: [u.name, u.surname].filter(Boolean).join(" ").trim() || u.username,
      pfp: u.pfp || null,
      account_kind: u.account_kind,
      watiId: u.wati_id || null,
      is_messaging_service_account: u.is_messaging_service_account === true,
      is_online: u.is_online === true,
    })).sort((a, b) => a.fullName.localeCompare(b.fullName));
    if (current === revision) cache = users;
    return users;
  }).catch(error => { if (strict) throw error; return []; })
    .finally(() => { if (pending === request) pending = null; });
  pending = request;
  return request;
}
